import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/FeaturedCategories/featuredCategories.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/HomePage/BestSeller/bestSeller.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/HomePage/CustomerReviews/customerReviews.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/kingsyard-ssr/src/components/HomePage/TopCarousel/topCarousel.js");
;
import(/* webpackMode: "eager" */ "/kingsyard-ssr/src/components/hover-prefetch-link.tsx");
